<template>
  <div class="layout">
    <div style="display: none">版本号：0.6.7</div>
    <transition name="fade">
      <div class="layout-header">
        <!-- 展位号添加 -->
        <img v-if="advertisement" @click="goPath('/modelone')"  src="../assets/images/component/BjMizcon2023_web_banner_mobile.png" alt=""
          style="width: 100%" />
        <Headerbar :hidden="hidden" :status="status" @show="show" @hide="hide"></Headerbar>
      </div>
    </transition>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
    <Mapbar></Mapbar>
    <Footerbar></Footerbar>
  </div>
</template>
<script>
  import Headerbar from '@/mlayout/component/Headerbar'
  import Footerbar from '@/mlayout/component/Footerbar'
  import Mapbar from '@/mlayout/component/Mapbar'
  export default {
    name: 'layout',
    data() {
      return {
        hidden: true,
        status: true,
        advertisement: true,
        i: 0
      }
    },
    components: {
      Headerbar,
      Footerbar,
      Mapbar
    },
    computed: {
      key() {
        return this.$route.fullPath
      }
    },
    created() {},
    mounted() {
      const wrapper = document.getElementsByClassName('layout')[0]
      window.addEventListener('scroll', this.handleScroll, true)
      // window.onresize = () => {
      //   return (() => {
      //     var width = document.documentElement.clientWidth
      //     if (windowWidth != width) {
      //       this.$router.go(0)
      //     }
      //   })();
      // };
    },
    methods: {
      goPath(path) {
        this.drawer = false
        this.contactUsshow = false
        this.$emit('show')
        if (path != this.$route.path) {
          this.$router.push({
            path: path
          })
        }
      },
      show() {
        this.hidden = true
      },
      hide() {
        this.hidden = true
      },
      handleScroll() {
        let top = document.documentElement.scrollTop
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        var scroll = scrollTop - this.i
        this.i = scrollTop
        // 根据滚动长度不同样式
        if (top < 200) {
          this.status = true
        } else {
          this.status = false
        }
        if (top > 320) {
          this.advertisement = false
        } else {
          this.advertisement = true
        }

        // 滚动时候隐藏顶部条
        if (top > 0 && scroll < 0) {
          // 鼠标向上
          this.hidden = true
        } else if (top > 0 && scroll > 0) {
          // 鼠标向下
          this.hidden = false
        }
      }
    },
    watch: {
      $route: {
        handler: function(val, oldVal) {
          if (val.path != oldVal.path) {
            this.hidden = true
          }
        },
        // 深度观察监听
        deep: true
      },
      windowHeight(val) {
        let that = this
        if (val != that.windowHeight) {
          this.$router.go(0)
        }
      }
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style lang="scss" scoped>
  .show {}

  .hide {
    width: 100vh;
    height: 100vh;
    overflow: hidden;
  }

  .layout {
    font-size: 0;
    max-width: 7.5rem;
    padding-top: 4.8rem;
    margin: auto;
  }

  .layout-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 2s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/mlayout/Layout.vue